import * as L from 'leaflet';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { placeholder } from '../../helpers';
import {
  defaultMapConfig,
  useMapConfig,
} from '../../../../components/SubjectsMap/helper';
import { findCoordinatesByCountry, useCountry } from '../../../../helpers/map';

export default function useSubjectDetails({ data, loading }) {
  const { TILE_LAYER_URL, MAP_TOKEN } = useMapConfig();
  const [mapRef, setMapRef] = useState();
  const [coordinates, setCoordinates] = useState();
  const container = useRef();
  const [country, setCoutry] = useState();
  const [closed, setClosed] = useState(false);
  const { getCountry } = useCountry();

  const actions = useMemo(() => ({
    closed,
    setClosed,
  }), [closed]);

  useEffect(() => {
    if (mapRef) {
      if (coordinates) {
        L.control.scale().addTo(mapRef);
        L.tileLayer(TILE_LAYER_URL, { access_token: MAP_TOKEN }).addTo(mapRef);
        const marker = L.marker(coordinates.coords, {
          icon: L.icon({
            iconUrl: '/assets/images/dashboard/map-icons/sca_location_pin.svg',
            iconSize: [36, 36],
          })
        }).addTo(mapRef);
        const popup = L.popup({
          closeOnClick: false,
          autoClose: false,
        })
          .setContent(coordinates.name);
        marker.bindPopup(popup).openPopup();
      }
    }
  }, [mapRef]);

  const primaryLocation = useMemo(() => {
    if (data.primaryLocation && data.primaryLocation.id) {
      return `${data.primaryLocation.name}${data.primaryLocation.level2 ? ` / ${data.primaryLocation.level2}` : ''}${data.primaryLocation.level1 ? ` / ${data.primaryLocation.level1}` : ''}`
    }
    return placeholder;
  }, [data.primaryLocation])

  useEffect(() => {
    if (data) {
      setCoutry(data.country);
    }
  }, [data]);

  const setCountryCoords = useCallback(() => {
    const countryCoord = findCoordinatesByCountry(country);
    setCoordinates({
      coords: countryCoord,
      name: getCountry(country),
    });
  }, [country, getCountry]);

  const fetchPrimaryLocation = useCallback(async (data) => {
    if (data.gps) {
      setCoordinates({
        coords: [data.gps.latitude, data.gps.longitude],
        name: data.name,
      });
    } else {
      setCountryCoords();
    }
  }, [country, setCountryCoords]);

  useEffect(() => {
    if (country && !coordinates) {
      if (data.primaryLocation) {
        fetchPrimaryLocation(data.primaryLocation);
      } else {
        setCountryCoords();
      }
    }
  }, [country, data]);

  const createInstance = () => {
    if (coordinates) {
      var c = L.DomUtil.get(document.getElementById(container.current));
      if (c != null) {
        c._leaflet_id = null;
      }
      const map = L.map(container.current, {
        ...defaultMapConfig,
        center: coordinates.coords,
        zoom: 6,
      });
      return map;
    }
  };

  useEffect(() => {
    if (mapRef) {
      return;
    }

    if (coordinates && !loading) {
      setMapRef(createInstance());
    }
  }, [coordinates, loading]);

  return {
    actions,
    container,
    primaryLocation,
  };
}
